import "./utilities_namespace.js";

window.Sparkle ??= {};
window.Sparkle.Utilities ??= {};

Sparkle.Utilities.eventOriginatedFrom = (event, elementOrSelector) => {
  return Sparkle.Utilities.eventOriginElement(event, elementOrSelector) != undefined;
};

Sparkle.Utilities.eventOriginElement = (event, elementOrSelector) => {
  if (!elementOrSelector) {
    return undefined;
  }

  // Unwrap the element if it's been jQuery'd
  if (elementOrSelector && elementOrSelector.jquery) {
    elementOrSelector = elementOrSelector[0];
  }

  // Handle jQuery events. Drill down to the native event so we can check if it was composed.
  // NOTE: If the event was triggered programmatically by jQuery, there may not be an original event, so all manipulation
  // should also work for a jQuery event, though we don't expect those to be composed. Also, old versions of jQuery,
  // like 1.11.x, will have an empty object for some events such as 'focusin'. In those cases we just stick with the
  // jQuery event and can't detect composed-ness.
  while (event.originalEvent && event.originalEvent !== event && !isEmpty(event.originalEvent)) {
    event = event.originalEvent;
  }

  // Return whether selector or element matches the event target or one of its ancestor elements
  const isString = typeof elementOrSelector === "string";
  if (isString && event.composed) {
    return event.composedPath().find((target) => target instanceof Element && target.matches(elementOrSelector));
  }
  if (isString) {
    return event.target?.closest(elementOrSelector);
  }
  if (event.composed) {
    return event.composedPath().find((target) => target === elementOrSelector);
  }

  let current = event.target;
  while (current) {
    if (current === elementOrSelector) {
      return current;
    }
    current = current.parentElement;
  }
  return undefined;

  function isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }
};
